import { render } from "./Accounts.vue?vue&type=template&id=7f1f73d3"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"
script.render = render

export default script